/**
 * Formats a number into a shortened string representation
 * @param num - The number to format
 * @returns Formatted string (e.g., 1000 -> "1k", 1120 -> "1.1k")
 */
export const formatNumber = (num: number): string => {
  if (num < 1000) return num.toString();
  
  const units = ['k', 'M', 'B', 'T'];
  const order = Math.floor(Math.log10(num) / 3);
  const unit = units[order - 1];
  const value = num / Math.pow(1000, order);
  
  // Format to 1 decimal place if the number is not a whole number
  const formattedValue = value % 1 === 0 ? value : value.toFixed(1);
  
  return `${formattedValue}${unit}`;
}; 